import React from "react";

function ContentWrapper({ children, lnbRef }) {
    return (
        <div className="displayOn leftBody h762" ref={lnbRef}>
            {children}
        </div>
    );
}

export default ContentWrapper;
